export default "__VITE_ASSET__DRC45IQT__"